import { render, staticRenderFns } from "./coaching-units-table.vue?vue&type=template&id=db24359e&"
import script from "./coaching-units-table.vue?vue&type=script&lang=js&"
export * from "./coaching-units-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports